import TrackedModel from "../tracked/trackedModel";
import {IListFormattable, ISortableContentElement} from "../../interfaces/contentManagementInterfaces";
import IRepo from "../../interfaces/repo";
import {RelationType} from "../relationType";
import {ISelectedProperty} from "../../state/modules/singleSelectedProperty";
import ContentElementable from "./contentElementable";
import Model from "../model";
import Guid from "../../helpers/guid";
import ElementHandler from "../../services/elementHandler";
import IProvider from "../../interfaces/provider";
import {ListFormatType} from '~/enums/listFormatType'

export default class ContentElement extends ContentElementable(TrackedModel) implements ISortableContentElement, IListFormattable {
  _classKey = "contentElement";
  rootModel: TrackedModel;
  content_type: number;
  sort_order: number;
  except = ['contentElement', 'createEmbeddedObject', 'organization', 'saveTimer', '_organization'];
  label_title: string;
  builtin_property_type: number;
  date_display_format?: number
  list_format_type: ListFormatType

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
  }

  static repo: IRepo<any, IProvider<Model>>;
  repo: IRepo<any, IProvider<Model>>;

  static get provider(): IProvider<Model> {
    return this.repo.provider;
  }

  get provider(): this['repo']['provider'] {
    return this.repo.provider;
  }

  get elementHandler(): ElementHandler {
    return this.contentElementHandler;
  }

  get builtinPropertyType(): number {
    return this.builtin_property_type;
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      content_elements: {type: typeof this, relationType: RelationType.dictionary},
    };
  }
  // // likely to be handled by inherited child
  // createEmbeddedObject = {
  //   content_elements: (parent: object, json: object): ContentElement => new ContentElement(),
  // };

  initialize(root, parent = root, type, json= {}) {
    this.rootModel = root;
    this.parent = parent;
    this.defineProperty('content_type', type);
    this.defineProperty('sort_order', 0);
    this.addDefaultProperties();
    this.loadFromJson(json);
    return this;
  }

  addDefaultProperties(){
  }
  //Overwritten in child
  get propertyDatetimeMode(){
    return null
  }

  static get rootName(): string {
    return 'content_elements';
  }

  get rootName(): string {
    return ContentElement.rootName;
  }

  addToRepo(): void {
    ContentElement.repo.add(this)
  }

  get selector(): ISelectedProperty {
    //implement in child
    return null;
  }

  select(): void {
    this.selector.set(this);
  }

  deselect(): void {
    this.selector.deselectIf(this);
  }

  get isSelectable(): boolean {
    return null;
  }

  get isSelected(): boolean {
    return false;
  }

  can(duty: number): boolean{
    return false;
  }

  afterDestroy() {
    super.afterDestroy();
    this.parent.contentElementHandler.recalculateElementPositions();
  }

  get isLast(): boolean {
    return this.sort_order === this.parent.nextSortOrderFor(this.rootName) - 1;
  }

  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  moveUp(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.parent.contentElementHandler.updateElementPositions(this.parent, this, this.sort_order);
    }
  }

  moveDown(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.parent.contentElementHandler.updateElementPositions(this.parent, this, this.sort_order);
    }
  }
}

